<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <div class="row">
        <div class="col-sm-3" v-for="picture in pictures" :key="picture.pictureId">
          <picture-input
            :id="picture.pictureId"
            ref="pictureInput"
            @change="picture.isNew ? onNew(picture.pictureId) : onChanged(picture.pictureId)"
            @remove="onRemoved(picture.pictureId)"
            :width="200"
            :removable="true"
            removeButtonClass="btn btn-danger btn-sm"
            :height="200"
            accept="application/pdf,image/gif,image/jpg,image/jpeg,image/png,image/svg"
            buttonClass="btn btn-primary btn-sm"
            :customStrings="{
          change: 'Change',
          remove: 'Delete'
        }"
            :prefill="picture.image"
            :prefillOptions="{fileName: picture.fileName, mediaType: picture.fileType}"
          ></picture-input>
          <!--<button type="button" class="btn btn-secondary btn-sm center" @click="download(picture)">Download</button>-->
        </div>
      </div>
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <album-settings :window-id="windowId" :album-id="albumId"></album-settings>
    </window-tab>
  </window>
</template>

<script>
  import { uuid } from '../lib'
  import { windowPropsMixin } from '../mixins'
  import * as action from '../store/action-types'
  import AlbumSettings from './album-settings'
  import PictureInput from 'vue-picture-input/PictureInput'

  export default {
    name: 'album',
    components: {AlbumSettings, PictureInput},
    mixins: [windowPropsMixin],
    computed: {
      albumId () {
        return this.$store.getters.windowData(this.windowId).contentId
      },
      album () {
        return this.$store.getters.album(this.albumId) || {}
      },
      pictures () {
        // Make copy of array in order to add an empty picture
        // with isNew flag
        const pictures = (this.album.pictures || []).slice(0)
        pictures.push({
          pictureId: uuid(),
          isNew: true
        })
        return pictures
      }
    },
    methods: {
      onNew (pictureId) {
        const input = this.$refs.pictureInput.find(pi => pi.id === pictureId)
        if (!input || !input.file) return
        this.$store.dispatch(action.ALBUM_PICTURE_CREATE, {
          albumId: this.albumId,
          pictureId: pictureId,
          fileName: input.file.name,
          fileType: input.file.type,
          fileSize: input.file.size,
          image: input.image
        })
      },
      onChanged (pictureId) {
        const input = this.$refs.pictureInput.find(pi => pi.id === pictureId)
        if (!input || !input.file) return
        this.$store.dispatch(action.ALBUM_PICTURE_CHANGE, {
          albumId: this.albumId,
          pictureId: pictureId,
          fileName: input.file.name,
          fileType: input.file.type,
          fileSize: input.file.size,
          image: input.image
        })
      },
      onRemoved (pictureId) {
        if (!pictureId) return
        this.$store.dispatch(action.ALBUM_PICTURE_REMOVE, {
          albumId: this.albumId,
          pictureId
        })
      },
      download (picture) {
        var pom = document.createElement('a')
        pom.setAttribute('href', picture.image)
        pom.setAttribute('download', picture.fileName)
        pom.style.display = 'none'
        document.body.appendChild(pom)
        pom.click()
        document.body.removeChild(pom)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/album.vue